import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetFailure, updateResetForm } from "../redux/userSlice";
import { resetPassword } from "../api/userAPI";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { Link } from "react-router-dom";

function ResetPassword() {
    // STATE/HOOKS =============================================================================================================
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const resetForm = useSelector(state => state.user.resetForm)
    const loading = useSelector(state => state.user.loading)

    // HANDLERS =============================================================================================================
    const validate = () => {
        let valid = true;

        if (resetForm.email === "") {
            valid = false;
            dispatch(resetFailure("Must enter an email"))
        } else if (resetForm.newPassword === "") {
            valid = false;
            dispatch(resetFailure("Must enter a password"))
        } else if (resetForm.newPassword !== resetForm.retypePassword) {
            valid = false;
            dispatch(resetFailure("Passwords do not match"))
        }

        return valid
    }

    const handleReset = (event) => {
        event.preventDefault();
        console.log(resetForm)
        if (validate()) {
            dispatch(resetPassword({
                email: resetForm.email,
                newPassword: resetForm.newPassword,
                navigate: navigate
            }))
        }
    }

    // DOM =============================================================================================================
    return(
        <div className="text-center">
            {loading && <div className="modal">
                <div className="modal-content">
                    <Loader />
                </div>
            </div>}

            <h1>Reset Password</h1>
            <form className="login shadow-lg mobile-w-10-12">

                <div>
                    <label htmlFor='email' className=''>email</label>
                    <input 
                        type="email" 
                        name="email" 
                        id="email" 
                        className='w-11/12' 
                        onChange={(event) => dispatch(updateResetForm({field: event.target.name, value: event.target.value}))} 
                        placeholder="Enter Email" 
                    />
                </div>

                <div>
                    <label htmlFor='password' className=''>password</label>
                    <input 
                        type="password"
                        name="newPassword" 
                        id="password" 
                        className='w-11/12' 
                        placeholder='Enter Password' 
                        onChange={(event) => dispatch(updateResetForm({field: event.target.name, value: event.target.value}))}
                    />
                </div>

                <div>
                    <label htmlFor='retype' className=''>re-type password</label>
                    <input 
                        type="password"
                        name="retypePassword" 
                        id="retype" 
                        className='w-11/12' 
                        placeholder='Retype Password' 
                        onChange={(event) => dispatch(updateResetForm({field: event.target.name, value: event.target.value}))}
                    />
                </div>

                <p>{resetForm.error}</p>

                <button className="block mx-auto my-3 btn-primary" onClick={(event) => handleReset(event)}>Submit</button>
                <Link to="/login"><span className="link-embedded">Back to login</span></Link>
            </form>
        </div>
    )
}

export default ResetPassword;